import React from 'react';

const Logo = ({ size = 'default', className = '', showText = true, showBars = true }) => {
  const sizes = {
    small: {
      container: 'gap-2',
      bars: { h3: 'h-2', h4: 'h-3', h6: 'h-4', w: 'w-1.5' },
      text: 'text-base'
    },
    default: {
      container: 'gap-3',
      bars: { h3: 'h-3', h4: 'h-4', h6: 'h-6', w: 'w-2' },
      text: 'text-xl'
    },
    large: {
      container: 'gap-4',
      bars: { h3: 'h-4', h4: 'h-5', h6: 'h-8', w: 'w-2.5' },
      text: 'text-2xl'
    }
  };

  const currentSize = sizes[size] || sizes.default;

  // If only showing bars, don't add container gap
  const containerClass = showText && showBars ? currentSize.container : '';

  return (
    <div className={`flex items-center ${containerClass} ${className}`}>
      {showBars && (
        <div className="flex items-end gap-1" aria-hidden="true">
          <span className={`${currentSize.bars.h3} ${currentSize.bars.w} rounded bg-brand-pink`} />
          <span className={`${currentSize.bars.h4} ${currentSize.bars.w} rounded bg-primary`} />
          <span className={`${currentSize.bars.h6} ${currentSize.bars.w} rounded bg-brand-gray-dark`} />
        </div>
      )}
      {showText && (
        <span className={`${currentSize.text} font-bold tracking-tight text-brand-gray-dark`}>
          GA4.so
        </span>
      )}
    </div>
  );
};

export default Logo;